<template>
  <div id="home" class="page">
    <b-alert v-if="alert_msg" show dismissible class="m-0" variant="warning">
      <div class="marquee_container" @mouseover="paused = true" @mouseleave="paused = false">
        <VTextMarquee :animate="!paused" :speed="speed">
          <div class="marquee_content" v-html="alert_msg" />
        </VTextMarquee>
      </div>
    </b-alert>
    <template v-if="!loading">
      <Banners
        v-if="!(!mobile_view && show_video) && data.top && data.top.length > 0"
        id="home_banners"
        :banners="data.top"
        :options="{dots: true, autoplay: true, infinite: true, arrows: false, speed: 2000, autoplaySpeed: 2000}"
      />
      <section
        v-if="data.bottom && data.bottom.length > 0"
        id="grids_mobile"
        class="grids container"
      >
        <div class="row">
          <template v-for="(grid, index) in data.bottom">
            <div
              v-if="!grid.grid_image_mobile"
              :id="`grid-${index}`"
              :key="`grid-${index}`"
              class="grid col-md-4 col-6"
            >
              <b-link
                class="d-block"
                v-bind="isExternalLink(grid.url)? { href: grid.url, target: '_blank'}: { to: grid.url}"
                :title="grid.headline"
              >
                <div v-lazy-container="{ selector: 'div' }" class="img_container">
                  <div v-lazy:background-image="getLazyLoadObj(grid.grid_image)" data-loading />
                </div>
                <div class="title_container">{{ grid.headline }}</div>
                <img class="btn_arrow" src="/images/btn_arrow.png" />
              </b-link>
            </div>
          </template>
        </div>
      </section>
    </template>
    <section
      v-if="data.bottom && data.bottom.length > 0"
      id="grids_mobile_only"
      class="grids container d-md-none"
    >
      <div class="row">
        <template v-for="(grid, index) in data.bottom">
          <b-link
            v-if="!grid.grid_image && grid.grid_image_mobile"
            :id="`grid-${index}`"
            :key="`grid-${index}`"
            class="grid col-6"
            v-bind="isExternalLink(grid.url)? { href: grid.url, target: '_blank'}: { to: grid.url}"
            :title="grid.headline"
          >
            <img width="100%" :src="getAssetLink(grid.grid_image_mobile)" />
            <div class="desc">{{ grid.headline }}</div>
          </b-link>
        </template>
      </div>
    </section>
    <section
      v-if="!loading"
      id="donate_btn_section"
      class="container clearfix pb-4 d-none d-md-block"
    >
      <DonateBtn v-view.once class="animated fadeInRight" />
    </section>
  </div>
</template>
<script>
import Banners from "@/components/Banners.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import VTextMarquee from "@/components/TextMarquee.vue";
import _ from "lodash";

export default {
  name: "Home",
  components: { Banners, DonateBtn, VTextMarquee },
  data() {
    var locale = this.$i18n.locale;
    var alert_msg =
      locale == "en"
        ? localStorage.getItem("alert_msg")
        : localStorage.getItem("alert_msg_cht");
    if (alert_msg) {
      alert_msg = alert_msg.trim();
      if (_.isEmpty(alert_msg)) {
        alert_msg = null;
      } else {
        alert_msg =
          "<span>" + alert_msg.split("|").join("</span><span>") + "</span>";
      }
    }

    var video_source = localStorage.getItem("video_source");
    return {
      mobile_view: false,
      loading: false,
      alert_msg: alert_msg,
      paused: false,
      speed: 40,
      show_video: _.isEmpty(video_source) ? false : true,
      data: {
        top: [],
        bottom: []
      },
      bannerOptions: {
        autoplay: true,
        autoplaySpeed: 2000
      }
    };
  },
  mounted() {
    this.loading = true;
    this.$http
      .get("home")
      .then(response => {
        this.data = response.data.data;
      })
      .finally(() => {
        this.loading = false;
      });

    // this.onResize();
    // window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      if (
        document.documentElement.clientWidth > this.$config.breakpoints.main
      ) {
        this.mobile_view = false;
      } else {
        this.mobile_view = true;
      }
    },
    getLazyLoadObj(src) {
      return {
        src: this.getAssetLink(src),
        error: this.$config.lazyload.grid,
        loading: this.$config.lazyload.grid
      };
    }
  }
};
</script>
<style scoped lang="scss" src="../assets/scss/home.scss"></style>
